var DetailEligDecController = (function () {
    function DetailEligDecController(topic, $scope, config, status, Dialog, socket, env) {
        this.topic = topic;
        this.$scope = $scope;
        this.config = config;
        this.status = status;
        this.Dialog = Dialog;
        this.socket = socket;
        this.env = env;
        this.emptyIdentified = false;
        this.completeSection = 'elig_dec';
        this.comp = 'elig_dec';
        this.updateArray = ['elig_dec'];
        this.statusUpdateFired = false;
        this.isElegibilityComplete = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
    }
    DetailEligDecController.prototype.$onInit = function () {
        //Set the suggested status on creation...it will match the current status
        this.suggestedStatus = this.config.getSubStatusBySubStatusNo2(3, this.topic.topic.status.sub_status_no);
        this.isElegibilityComplete = this.topic.isEligibilityDecisionButtonHide();
        if (this.topic.checksData && this.topic.checksData.uiVersion >= this.OPP_VERSION_3) {
            this.dealRegEligDecision = this.topic.topic.elig_dec.eligibilityDecision;
            this.eligibilityUiVersion = this.topic.checksData.uiVersion;
        }
    };
    DetailEligDecController.prototype.updateStatus = function (event) {
        var _this = this;
        if (this.topic.updatePartialSocketStatus(['gpp', 'comments$eligibility'], 'Updating')) {
            if (this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.REJECTED) {
                this.status.rejectDisbursement(event, this.topic, function (err, rejBundle) {
                    if (!err) {
                        _this.topic.sendForUpdate(['status'], rejBundle.action, rejBundle.comments, false);
                        _this.status.eligDecisionFired = true;
                    }
                });
            }
            else {
                //Prepare to ask question...based on event
                var items = {
                    icon: 'QUESTION',
                    message: 'Should you choose to continue, the Disbursement will become locked and uneditable. &nbsp;Do you want to continue?',
                    title: this.topic.topic.elig_dec.eligibilityDecision
                };
                //Ask it...
                this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                    //If clicked no
                    if (!dResult.confirm) {
                        return; //Die
                    }
                    else {
                        if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.PARTIALLY_ELIGIBLE) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 4).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.SOLUTION_ONLY) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 23).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.ENGAGEMENT_ONLY) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 32).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.FULLY_ELIGIBLE) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 3).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.SPECIAL_BID_ONLY) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 28).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.SOLUTION_AND_SPECIAL_BID_ONLY) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 29).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                        else if (_this.topic.topic.elig_dec.eligibilityDecision === EligibilityDecision.ENGAGEMENT_AND_SPECIAL_BID_ONLY) {
                            _this.topic.temp_ext.sub_status = _this.config.getSubStatusBySubStatusNo2(3, 33).txt;
                            _this.topic.sendForUpdate(['status'], 'Eligibility Decision', '', false);
                            _this.status.eligDecisionFired = true;
                        }
                    }
                });
            }
        }
    };
    /**
     * Returns true if button is disabled
     * @returns {boolean}
     */
    DetailEligDecController.prototype.isButtonDisabled = function () {
        return !(this.topic.topic.complete.statusComplete['3']
            && [
                EligibilityDecision.PARTIALLY_ELIGIBLE,
                EligibilityDecision.SOLUTION_ONLY,
                EligibilityDecision.FULLY_ELIGIBLE,
                EligibilityDecision.SOLUTION_AND_SPECIAL_BID_ONLY,
                EligibilityDecision.SPECIAL_BID_ONLY,
                EligibilityDecision.ENGAGEMENT_ONLY,
                EligibilityDecision.ENGAGEMENT_AND_SPECIAL_BID_ONLY,
                EligibilityDecision.REJECTED,
            ].includes(this.topic.topic.elig_dec.eligibilityDecision))
            || this.status.eligDecisionFired
            || this.topic.usFed.status
            || this.topic.topic.elig_dec.eligibilityDecision === 'Unknown'
            || this.topic.editableComponents.elig_dec.socket !== ''
            || (!this.topic.topic.gpp[0].dup_check_flg && this.topic.newUI);
    };
    DetailEligDecController.$inject = ['topic', '$scope', 'config', 'status', 'Dialog', 'socket', 'env'];
    return DetailEligDecController;
}());
var DetailEligDecComponent = (function () {
    function DetailEligDecComponent() {
        this.templateUrl = 'detail-elig-decision.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligDecController;
    }
    return DetailEligDecComponent;
}());
angular
    .module('application')
    .component('eligibilityDecisionSection', new DetailEligDecComponent());

//# sourceMappingURL=detail.eligibility.decision.component.js.map
